import { Portal } from "@ark-ui/react";
import { toasters } from "./toastr";
import { Toaster } from "./Toaster";

export const ToastPortal = () => {
  return (
    <Portal>
      {Object.values(toasters).map((toaster, index) => (
        <Toaster key={index} toaster={toaster} />
      ))}
    </Portal>
  );
};
